export default __webpack_public_path__ + "static/media/aquarium-03.357331a6.png";